// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"11":"66b1a7d1","485":"5a678207"}[chunkId] + ".chunk.css";
};